package com.nonopn.skywatcher.common.app.pages.map.view.left

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.LocalApplicationColorTheme
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal
import eu.codlab.viewmodel.rememberViewModel

@Composable
fun DateSection(
    modifier: Modifier,
) {
    val colors = LocalApplicationColorTheme.current

    val model = rememberViewModel { DateSectionModel() }
    val state by model.states.collectAsState()
    val dateTranslation = state.dateTranslation
    val sizes = LocalFontSizes.current.weatherColumn

    Column(
        modifier = modifier.padding(8.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        TextNormal(
            modifier = Modifier.padding(bottom = 8.dp),
            text = "${dateTranslation.weekDay.localized()}, " +
                    "${dateTranslation.day} " +
                    "${dateTranslation.month.localized()} " +
                    "${dateTranslation.year}",
            color = colors.fonts.regularLighter,
            fontSize = sizes.dateSectionTitle,
        )
        TextNormal(
            text = state.hours,
            fontSize = sizes.hourSectionTitle,
        )
    }
}

@HotPreview(widthDp = 400, heightDp = 200, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 200, darkMode = false)
@Composable
private fun DateSectionPreview() {
    HotPreviewApp(
        isDarkTheme = isSystemInDarkTheme()
    ) {
        DateSection(Modifier.fillMaxSize())
    }
}